import { getActionButtonProps, getIsUsedExternalLink } from './get-action-button-props';

export function smartActionButtonValidator({
  siteConfig, componentId, i18n, pilots = {},
}) {
  const {
    dataSourceValue,
    linkText,
    linkUrl,
    componentConfig,
    validator,
    readProcessor,
  } = getActionButtonProps(siteConfig, componentId);

  const values = {
    dataSourceValue: readProcessor(dataSourceValue),
    linkText,
    linkUrl,
    isExternalLink: getIsUsedExternalLink(componentConfig),
  };
  const errors = validator(values, i18n, pilots);

  return {
    isValid: !errors,
    errors: errors ? [errors] : null,
  };
}
